/* global TweenMax, */
function slider() {
	var active = $('.slider .slides .active');
	var next = $('.slider .slides .next');
	
	TweenMax.set(active, {
		'autoAlpha': 1
	});

	TweenMax.set(next, {
		'autoAlpha': 1
	});


    TweenMax.to(active, 1, {
        autoAlpha: 0,
        // ease: Power0.easeNone,
        onComplete: function() {
            // console.log('ended');
            active.removeClass('active');
            active.appendTo($('.slider .slides'));
            next.removeClass('next').addClass('active');
            next.next().addClass('next');
        }
    });
}

// slider();
setInterval(function() {
	slider();
}, 5000);